/* eslint-disable import/no-extraneous-dependencies */
import React, {useRef, useState, useEffect} from 'react';
import DOMPurify from 'dompurify';
import {useSize} from 'ahooks';
import {Dropdown, Menu, Input} from '@enos/dpl';
import localeText, {getLocale} from '@locale';
// import _ from 'lodash';
import {LAN_EN_KEY, LAN_ZH_KEY} from '~/utils/constant';
import Logo from '~/assets/images/top_logo_global.png';
import {setLanguage} from '~/utils/tools';
import zhContext from '~/locale/zh-CN.js';
import './index.less';

const {Search} = Input;

const Header = ({locale, version, pageSize, isTutorial, configData, versionKeys, insertTheme = false, history, isLanding}) => {
  const langList = [
    {
      label: 'English',
      key: LAN_EN_KEY
    },
    {
      label: zhContext.COMMON.CHINESE,
      key: LAN_ZH_KEY
    }
  ];
  const content = useRef(null);
  const contentSize = useSize(content);
  const right = useRef(null);
  const rightSize = useSize(right);
  const [headerStyle, setHeaderStyle] = useState({width: '100%'});
  const [listStyle, setListStyle] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [footerHover, setFooterHover] = useState(false);
  const versionDrop = (
    <Menu className='dropdown-wrapper-version'>
      {
        versionKeys.map((item) => (
          <Menu.Item
            className={item === version ? 'active' : ''}
            onClick={() => {
              if (insertTheme) {
                const url = window.location.href.replace(/\/(zh_CN|en)\/((\d+.\d+.\d+)|dev|stable|preview|master|latest)\//, `/${locale}/${item}/`);
                window.location.href = DOMPurify.sanitize(url);
              } else {
                history.push(`/${locale}/${item}${isTutorial ? '/tutorial' : ''}`);
              }
            }}
          >
            <span>{item}</span>
          </Menu.Item>
        ))
      }
    </Menu>
  );
  const localeDrop = (
    <Menu className='dropdown-wrapper-locale'>
      {
        langList.map((item) => (
          <Menu.Item
            className={item.key === locale ? 'active' : ''}
            onClick={() => {
              if (insertTheme) {
                const url = window.location.href.replace(/\/(zh_CN|en)\/((\d+.\d+.\d+)|dev|stable|preview|master|latest)\//, `/${item.key}/${version}/`);
                window.location.href = DOMPurify.sanitize(url);
              } else {
                setLanguage(item.key);
                history.push(`/${item.key}/${version}${isTutorial ? '/tutorial' : ''}`);
              }
            }}
          >
            <span>{item.label}</span>
          </Menu.Item>
        ))
      }
    </Menu>
  );

  useEffect(() => {
    if (pageSize && pageSize.width) {
      setHeaderStyle({width: `${pageSize.width}px`});
      if (contentSize && contentSize.width && rightSize && rightSize.width) {
        const listItems = document.querySelectorAll('.new-header .header-list .content-item');
        const listItemsHidden = document.querySelectorAll('.new-header .header-list .content-item-hidden');
        // if (contentSize.width >= 138 && contentSize.width <= 142) {
        if (contentSize.width === 140) {
          const listsWidth = pageSize.width * 0.875 - 30 - rightSize.width - contentSize.width - 40;
          setListStyle({
            maxWidth: `${listsWidth}px`
          });

          const listItemsWidth = [];
          listItems.forEach((list) => { listItemsWidth.push(list.offsetWidth); });
          const listItemsHiddenWidth = [];
          listItemsHidden.forEach((list) => { listItemsHiddenWidth.push(list.offsetWidth); });

          const maxList = Math.max(...listItemsWidth);
          const maxIndexes = [];
          listItemsWidth.forEach((list, index) => {
            if (list === maxList) {
              maxIndexes.push(index);
            }
          });
          if (listItemsWidth.reduce((pre, nex) => pre + nex, 0) > (listsWidth - (configData.length - 1) * 40)) {
            maxIndexes.forEach((index) => {
              listItems[index].style.overflow = 'hidden';
              listItems[index].style.textOverflow = 'ellipsis';
            });
          }
        } else {
          setListStyle({});
          listItems.forEach((list) => {
            list.style.overflow = 'unset';
            list.style.textOverflow = 'unset';
          });
        }
      }
    }
  }, [pageSize]);
  // }, [pageSize, contentSize, rightSize]);

  useEffect(() => {
    const listenerScroll = () => {
      const scrollPosition = window.scrollY;
      const header = document.querySelector('#root .new-header');
      if (header) {
        const scrollX = window.scrollX;
        if (scrollPosition > 0) {
          header.style.backgroundColor = '#111111';
        } else {
          header.style.backgroundColor = 'transparent';
        }
        header.style.transform = `translateX(-${scrollX}px)`;
      }
    };
    window.addEventListener('scroll', listenerScroll);
    return () => {
      window.removeEventListener('scroll', listenerScroll);
    };
  }, []);

  const extractInfo = (string) => {
    const projectName = string?.split('/docs/')?.[1]?.split('/')?.[0];
    const language = string?.split('/docs/')?.[1]?.split('/')?.[1];
    if (language === 'en') {
      return projectName;
    }
    if (language === 'zh_CN') {
      return `${projectName}-zh`;
    }
  };

  return (
    <div className={`new-header ${insertTheme ? 'theme' : ''}`} style={headerStyle}>
      <div className='header-left'>
        <div
          className='logo-wrap'
          onClick={() => {
            window.location.href = DOMPurify.sanitize(`/docs/${locale}/${version}`);
          }}
        >
          <img className='logo' src={Logo} alt='logo' />
        </div>
        <div className='space' />
      </div>
      <div className='header-list' style={listStyle}>
        {
          configData.map((element, inde) => (
            <Dropdown
              overlay={(
                <div className={`dropdown-wrapper-header-list ${element.layout} ${element?.item?.length > 1 ? 'muti' : 'single'}`} key={inde}>
                  <div className='dropdown-content'>
                    {element?.item?.map((item, ind) => (
                      <div className='dropdown-content-item' key={ind}>
                        {item?.title ? (
                          <>
                            <p className='dropdown-content-item-title'>{item?.title}</p>
                            <hr />
                          </>
                        ) : null}
                        <div className='dropdown-content-item-list'>
                          {item?.list?.map((list, index) => (
                            <span
                              className='dropdown-content-item-list-item'
                              key={index}
                              onClick={() => window.open(list.url)}
                              // src={list.url}
                            >
                              <a target='blank'>{list.name}</a>
                            </span>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  {element.footer ? (
                    <>
                      <hr />
                      <div
                        className={`dropdown-footer ${footerHover ? 'hover' : ''}`}
                        onMouseOver={() => setFooterHover(true)}
                        onMouseOut={() => setFooterHover(false)}
                        onFocus={() => undefined}
                        onBlur={() => undefined}
                        onClick={() => window.open(element.footer.url)}
                      >
                        <img src={require(`~/${element.footer.image}`)} alt={element.footer.name} />
                        <span className='dropdown-footer-text'>{element.footer.name}</span>
                        <i className='dpl20_right_s' />
                      </div>
                    </>
                  ) : null}
                </div>
              )}
            >
              <div
                className='content-item'
              >
                {element.category}
              </div>
            </Dropdown>
          ))
        }
      </div>
      <div className='header-content' ref={content}>
        <Search
          className='global-search'
          placeholder={localeText('COMMON.SEARCH_DOCUMENT')}
          allowClear
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onPressEnter={() => {
            const project = isLanding ? 'all' : extractInfo(window.location.href);
            const searchParams = `?q=${searchValue}&version=${version}&page=1&page_size=10&language=${locale}&project=${project}&source=${window.location.href}`;
            window.location.href = DOMPurify.sanitize(`/docs/${locale}/globalSearch${searchParams}`);
          }}
        />
      </div>
      <div className='header-right' ref={right}>
        <div className='header-right-switcher'>
          <div
            className='contact-us'
            onClick={() => {
              const subj = 'Report%20Vulnerabilities';
              const body1 = 'Product%20name%3A%0AProduct%20version%3A';
              const body2 = '%0AProduct%20impact%20description%3A%0AScreenshot%3A%0ARemark%3A';
              const url = `mailto:security@univers.com?subject=${subj}&body=${body1}${body2}`;
              window.location.href = url;
            }}
          >
            {localeText('COMMON.CONTACT_US')}
          </div>
          <div className='version-switcher'>
            <Dropdown overlay={versionDrop}>
              <span className='version-option'>
                {version}
                <i className='dpl20_down' />
              </span>
            </Dropdown>
          </div>
          <div className='locale-switcher'>
            <Dropdown overlay={localeDrop}>
              <span className='locale-option'>
                {getLocale() === 'en-US' ? 'English' : zhContext.COMMON.CHINESE}
                <i className='dpl20_down' />
              </span>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
